var Aneox;
(function (Aneox) {
    (function (Controllers) {
        'use strict';

        var Contact = (function () {
            
            var self;

            function Contact(animations) {
                self = this;
                
                self.timeline = animations.timeline;
            }

            Contact.prototype.enter = function () {
                self.timeline.set('#contact', { display: 'block', opacity: 0 });
                self.timeline.set('#contact-aside', { display: 'block', opacity: 0 });

                self.timeline.call(self.handleWindowResize.bind(self));
                self.timeline.call(function () { $("html, body").scrollTop(0); });

                self.timeline.to('#contact', 0.5, { opacity: 1 });
                self.timeline.to('#contact-aside', 0.5, { opacity: 1 }, '-=0.5');
                
                self.timeline.set('#contact .mask', { display: 'block', top: 0 }, 0);
                self.timeline.to('#contact-mast .mask', 1, { top: '100%' });
            };

            Contact.prototype.leave = function (callback) {
                self.timeline.to('#contact', 0.5, { display: 'none', opacity: 0 });
                self.timeline.to('#contact-aside', 0.5, { display: 'none', opacity: 0 }, '-=0.5');

                if (callback) self.timeline.call(callback);
            };

            Contact.prototype.handleWindowResize = function () {
            };

            return Contact;
        })();

        Controllers.Contact = Contact;
    })(Aneox.Controllers || (Aneox.Controllers = {}));
})(Aneox || (Aneox = {}));